/* eslint-disable */
/* eslint-disable react/no-children-prop */
/* eslint-disable no-console */
/**
 * SQ_ACS_2
 */
import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Box,
  RACButton,
  RACModalCard,
} from '@rentacenter/racstrap';
import { useTranslation } from 'react-i18next';
import CurrencyInput from 'react-currency-input-field';
import { availableCreditsStyle } from '../stylesJS/availableCreditsStyle';
import { agreementContext } from '../context/PaymentInformationContext';
import { CreditsValue, RewardAmountObject } from '../interface/availableCreditsInterface';
import CONSTANTS from '../constants/constant';
import { calculatePaymentModule, RefundWebLeadAmount } from '../../api/user';
import { ReactComponent as Alerticon } from './../../assets/images/apiErrorIcon.svg';
import { ReactComponent as TickIcon } from './../../assets/images/TickIcon.svg';
import { AgreementDetails } from '../interface/paymentInfoInterface';
import { customerRewardDetailFormation, groupAgreementsByStore } from '../../utils/utils';
import calculationModulePayloadFormation from './existingFunctions/commonModulePayloadFormation';

/**
 * SQ_ACS_3
 * @returns
 */
export function AvailableCredits() {
  /**
   * SQ_ACS_4
   */
  const classes = availableCreditsStyle();
  const agreementInfo = useContext(agreementContext);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [messagePopup, setMessagePopup] = useState<boolean>(false);
  const [messageType, setMessageType] = useState<string>('');
  const { t } = useTranslation('BackRent');
  const [message, setMessage] = useState<string>('');
  let [rewardAmount, setRewardAmount] = useState<RewardAmountObject>({
    displayUpdatedAmount: CONSTANTS.ZREO_TWO_DECIMAL_STRING,
    originalAmount: CONSTANTS.ZREO_TWO_DECIMAL_STRING,
    editedAmount: CONSTANTS.ZREO_TWO_DECIMAL_STRING
  })
  const [rewardLoader, setRewardLoader] = useState(false)
  const [disableApplyBtn, setDisableApplyBtn] = useState(false)

  const prevAgreementSelectionRef = useRef<boolean[]>([]);
  const isProcessingSelectionChangeRef = useRef<boolean>(false);

  const isFirstLoadRef = useRef(true);
  const originalClubRef = useRef<number | null>(null);

  useEffect(() => {
    if (isFirstLoadRef.current) {
      isFirstLoadRef.current = false; // Set it to false after the first load
    }
  }, []); 

  useEffect(() => {
    if (isProcessingSelectionChangeRef.current) {
      return;
    }

    if (!agreementInfo?.agreementDetails?.length) {
      return;
    }

    const currentSelectionState = agreementInfo.agreementDetails.map(item => !!item.selected);

    if (prevAgreementSelectionRef.current.length > 0) {
      const selectionChanged = JSON.stringify(currentSelectionState) !==
        JSON.stringify(prevAgreementSelectionRef.current);

      const hasAppliedRewards = agreementInfo.agreementDetails.some(item =>
        Number(item?.appliedRewardAmount || 0) > 0
      );

      if (selectionChanged && hasAppliedRewards) {
        isProcessingSelectionChangeRef.current = true;
        console.log("Selection changed with applied rewards - resetting reward amounts only");

        const newRewardAmount = {
          ...rewardAmount,
          editedAmount: CONSTANTS.ZREO_TWO_DECIMAL_STRING,
          displayUpdatedAmount: rewardAmount.originalAmount ||
            agreementInfo?.customerInfo?.customerRewardDetails?.rewardAmount ||
            CONSTANTS.ZREO_TWO_DECIMAL_STRING
        };

        const newCustomerInfo = {
          ...agreementInfo.customerInfo,
          customerRewardDetails: {
            ...agreementInfo.customerInfo.customerRewardDetails,
            rewardApplied: CONSTANTS.ZREO_TWO_DECIMAL_STRING,
          }
        };

        const newAgreementDetails = agreementInfo.agreementDetails.map((detail, index) => {
          const originalDetail = agreementInfo.agreementDetailsDeepClone[index];

          if (originalDetail) {
            return {
              ...detail,
              selected: detail.selected,
              appliedRewardAmount: CONSTANTS.ZREO_TWO_DECIMAL_STRING,
              totalDueAmount: originalDetail.totalDueAmount,
              totalAmount: originalDetail.totalAmount,
              totalTax: originalDetail.totalTax
            };
          }
          return {
            ...detail,
            appliedRewardAmount: CONSTANTS.ZREO_TWO_DECIMAL_STRING
          };
        });

        setRewardAmount(newRewardAmount);
        agreementInfo.setCustomerInfo(newCustomerInfo);
        agreementInfo.setAgreementDetails(newAgreementDetails);

        agreementInfo.setRenderContext(!agreementInfo.renderContext);

        setTimeout(() => {
          isProcessingSelectionChangeRef.current = false;
        }, 300);
      }
    }

    prevAgreementSelectionRef.current = currentSelectionState;

    if (agreementInfo.featureFlags.EnableCustomerRewardPayment == '1') {
      if (agreementInfo?.agreementDetails.length > 0 && !agreementInfo.customerInfo?.customerRewardDetails?.isAdvocate) {
        const rafRewardDetails = customerRewardDetailFormation(
          agreementInfo?.agreementDetails,
          agreementInfo?.customerInfo?.customerRewardDetails?.rewardAmount
        );
        agreementInfo.setCustomerInfo((prevState) => ({
          ...prevState,
          customerRewardDetails: rafRewardDetails
        }));
      }
    }

    const selectedAgreement = agreementInfo.agreementDetails.filter((val) => val.selected);

    selectedAgreement.forEach((val) => {
      if (val.agreementType === "Club") {
        if (originalClubRef.current === null) { // Check if originalClub has not been set
          originalClubRef.current = Number(val.totalAmount); // Set it once
        }
        console.log(val.totalAmount, val.appliedRewardAmount, "reward check");
      }
    });

    rewardApplyDisable();
  }, [agreementInfo?.agreementDetails]);  

  useEffect(() => {
    const rewardApplied = agreementInfo.agreementDetails.reduce((accum: number, item: AgreementDetails) => accum + Number(item.selected ? item?.appliedRewardAmount ?? CONSTANTS.ZERO_NUMBER : CONSTANTS.ZERO_NUMBER), CONSTANTS.ZERO_NUMBER)
    if (rewardApplied != Number(agreementInfo?.customerInfo?.customerRewardDetails?.rewardApplied) && agreementInfo.customerInfo?.customerRewardDetails?.isAdvocate) {
      agreementInfo.setCustomerInfo((prevState) => ({
        ...prevState,
        customerRewardDetails: agreementInfo.customerInfoDeepClone.customerRewardDetails
      }));

      agreementInfo.setAgreementDetails((prevDetails) =>
        prevDetails.map((detail, i) => {
          if (
            detail?.agreementId === agreementInfo.agreementDetailsDeepClone[i]?.agreementId &&
            Number(detail?.appliedRewardAmount) > 0
          ) {
            // Check if detail is not selected
            if (!detail.selected) {
              // Create a copy of the deep-cloned object and update its 'selected' property
              const copyObj = { ...agreementInfo.agreementDetailsDeepClone[i], selected: false };
              return copyObj;
            } else {
              return agreementInfo.agreementDetailsDeepClone[i];
            }
          } else {
            return detail;
          }
        }
        )
      );
      agreementInfo.setRenderContext(!agreementInfo.renderContext);
    }

    if (agreementInfo.customerInfo?.customerRewardDetails?.isReferer) {
      const modulueLoad = async () => {
        const selectedAgreements = agreementInfo.agreementDetails.filter((val) => val.selected)
        agreementInfo.setOtherActionLoader(true);
        let commonModulePayload = await calculationModulePayloadFormation({
          customerId: agreementInfo.customerInfo?.customerId,
          storeNumber: window.sessionStorage.getItem("storeNumber"),
          checkedAgr: selectedAgreements
        })

        let commonModuleServiceRes = await calculatePaymentModule(commonModulePayload)

        updateAgreementDetails(commonModuleServiceRes, selectedAgreements)
        agreementInfo.setOtherActionLoader(false)
      }

      modulueLoad()
    }
  }, [agreementInfo.rewardRest])


  useEffect(() => {
    if (agreementInfo?.customerInfo?.remainingCredits?.some((val) => val.bucket == CONSTANTS.REFER_A_FRIEND)
      && agreementInfo?.customerInfo?.customerRewardDetails?.rewardApplied == CONSTANTS.ZREO_TWO_DECIMAL_STRING
      && agreementInfo.customerInfo?.customerRewardDetails?.isAdvocate) {
      setRewardAmount({
        ...rewardAmount, originalAmount: agreementInfo?.customerInfo?.customerRewardDetails.rewardAmount,
        displayUpdatedAmount: agreementInfo?.customerInfo?.customerRewardDetails.rewardAmount, editedAmount: CONSTANTS.ZREO_TWO_DECIMAL_STRING
      });
    }
    else if (agreementInfo?.customerInfo?.remainingCredits?.some((val) => val.bucket == CONSTANTS.REFER_A_FRIEND)
      && !agreementInfo.customerInfo?.customerRewardDetails?.isAdvocate) {
      const appliedAmount = agreementInfo?.customerInfo?.customerRewardDetails?.rewardApplied;
      const rewardAmountOriginal = agreementInfo?.customerInfo?.customerRewardDetails?.rewardAmount;

      const remainingReward = Number(appliedAmount) <= Number(rewardAmountOriginal) ?
        (Number(rewardAmountOriginal) - Number(appliedAmount)).toFixed(2) : CONSTANTS.ZREO_TWO_DECIMAL_STRING;

      setRewardAmount({
        ...rewardAmount, displayUpdatedAmount: Number(remainingReward).toFixed(2),
        editedAmount: appliedAmount ?? CONSTANTS.ZREO_TWO_DECIMAL_STRING
      });

    }
  }, [agreementInfo?.customerInfo])

  const applyRewards = async () => {
    const selectedAgreement = agreementInfo.agreementDetails.filter((val) => val.selected && !CONSTANTS.REWARD_AGREEMENT_TYPE_NOT_ALLOWED.includes(val.agreementType));
    setRewardLoader(true);
    let commonModulePayload = await calculationModulePayloadFormation({
      customerId: agreementInfo.customerInfo?.customerId,
      storeNumber: window.sessionStorage.getItem("storeNumber"),
      checkedAgr: selectedAgreement,
      appliedRewardAmount: rewardAmount.editedAmount
    })

    let commonModuleServiceRes = await calculatePaymentModule(commonModulePayload)

    setRewardLoader(false);
    updateAgreementDetails(commonModuleServiceRes, selectedAgreement);

    const remainingReward = Number(rewardAmount.editedAmount) <= Number(rewardAmount.originalAmount) ?
      (Number(rewardAmount.originalAmount) - Number(rewardAmount.editedAmount)).toFixed(2) : CONSTANTS.ZREO_TWO_DECIMAL_STRING;

    setRewardAmount({ ...rewardAmount, displayUpdatedAmount: remainingReward });
    agreementInfo.setCustomerInfo((prevState) => ({
      ...prevState,
      customerRewardDetails: {
        ...prevState?.customerRewardDetails,
        rewardApplied: rewardAmount.editedAmount ?? CONSTANTS.ZREO_TWO_DECIMAL_STRING,
      }
    }));

    agreementInfo.setRenderContext(!agreementInfo.renderContext)
  }

  const rewardsOnChage = (val) => {
    let sanitizedValue = val
      .replace(/[^0-9.]/g, '')
      .replace(/(\..*)\./g, '$1');

    // Limit to two decimal places
    const parts = sanitizedValue.split('.');
    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2);
      sanitizedValue = parts.join('.');
    }
    setRewardAmount({ ...rewardAmount, editedAmount: sanitizedValue });
  }

  const updateAgreementDetails = (commonModuleServiceRes, selectedAgreement) => {
    if (commonModuleServiceRes.status == 200) {
      const groupByStoreNumber = groupAgreementsByStore(selectedAgreement)
      const keys = Object.keys(groupByStoreNumber);
      keys.forEach((val) => {
        let currentStorePaymentDetails = commonModuleServiceRes?.data?.paymentDetails.filter((el) => el.storeNumber == val)

        for (let i = 0; i < selectedAgreement?.length; i++) {
          if (selectedAgreement[i].storeNumber == val) {

            let agreements;
            let index;

            if (selectedAgreement[i].agreementType != CONSTANTS.CLUB) {
              agreements = currentStorePaymentDetails[0].agreementPaymentDetails.filter((el) => el?.agreementId == selectedAgreement[i]?.agreementId);
              index = agreementInfo.agreementDetails.findIndex((vl) => vl.agreementId == selectedAgreement[i].agreementId);
            } else {
              agreements = currentStorePaymentDetails[0].clubPaymentDetails.filter((el) => el?.customerClubId == selectedAgreement[i]?.agreementId);
              index = agreementInfo.agreementDetails.findIndex((vl) => vl.agreementId == selectedAgreement[i].agreementId);
            }

            if (index >= 0 && agreements.length > 0) {
              agreementInfo.setAgreementDetails((prevDetails) =>
                prevDetails.map((detail, i) =>
                  i === index
                    ? {
                      ...detail,
                      totalTax: agreements[0].totalTax,
                      totalDueAmount: Number(Number(agreements[0].totalAmount) + Number(agreements[0].totalTax)).toFixed(2),
                      totalAmount: Number(agreements[0].totalAmount).toFixed(2),
                      appliedRewardAmount: agreements[0]?.appliedRewardAmount ? agreements[0]?.appliedRewardAmount : CONSTANTS.ZREO_TWO_DECIMAL_STRING
                    }
                    : detail
                )
              );
            }
          }
        }
      })
    }

    const remainingReward = Number(rewardAmount.editedAmount) <= Number(rewardAmount.originalAmount) ?
      (Number(rewardAmount.originalAmount) - Number(rewardAmount.editedAmount)).toFixed(2) : CONSTANTS.ZREO_TWO_DECIMAL_STRING;

    setRewardAmount({ ...rewardAmount, displayUpdatedAmount: remainingReward });
    agreementInfo.setCustomerInfo((prevState) => ({
      ...prevState,
      customerRewardDetails: {
        ...prevState?.customerRewardDetails,
        rewardApplied: rewardAmount.editedAmount ?? CONSTANTS.ZREO_TWO_DECIMAL_STRING,
      }
    }));

    agreementInfo.setRenderContext(!agreementInfo.renderContext)
  }

  const validateEligibleRewardAmount = () => {
    const selectedAgreement = agreementInfo.agreementDetails.filter((val) => val.selected);

    // Initialize total amounts
    let totalRentalAmount = 0;
    let totalClubAmount = 0;

    // Iterate through selected agreements and calculate totals based on agreement type
    selectedAgreement.forEach((val) => {
      if (val.agreementType === "Rental Agreement (RTO)") {
        totalRentalAmount += Number(val.rentalAmount ?? 0);
      } else if (val.agreementType === "Club") {
        console.log(originalClubRef.current, "inside club and value-");
        totalClubAmount += Number(originalClubRef.current ?? 0)
      }
    });
    // Combine both amounts
    const combinedTotalAmount = totalRentalAmount + totalClubAmount;
    console.log(combinedTotalAmount, "combinedTotalAmount");

    if (Number(rewardAmount.editedAmount) > combinedTotalAmount) {
      setMessagePopup(true);
      setMessageType('REWARDAMOUNT');
      setMessage(`The maximum amount of RAC Rewards that may be applied to the selected agreement(s) is $${Number(isNaN(combinedTotalAmount) ? CONSTANTS.ZERO_NUMBER : combinedTotalAmount ?? CONSTANTS.ZERO_NUMBER).toFixed(2)}.`);
      setRewardAmount({ ...rewardAmount, totalRentalAmount: Number(combinedTotalAmount).toFixed(2) });
    } else {
      applyRewards();
    }
  }


  const rewardsOnBlur = (val: string) => {
    if (val != CONSTANTS.EMPTY_STRING || val != CONSTANTS.ZREO_TWO_DECIMAL_STRING) {
      let removeComma = String(val).replace(
        CONSTANTS.REPLACE_COMMA,
        CONSTANTS.EMPTY_STRING
      );
      setRewardAmount({ ...rewardAmount, editedAmount: Number(removeComma).toFixed(2) });
    }
    else
      setRewardAmount({ ...rewardAmount, editedAmount: CONSTANTS.ZREO_TWO_DECIMAL_STRING })
  }
  const rewardApplyDisable = () => {
    if (agreementInfo?.agreementDetails.length > 0) {
      let isButtonDisable = agreementInfo?.agreementDetails?.some((val) => val?.selected && !CONSTANTS.REWARD_AGREEMENT_TYPE_NOT_ALLOWED.includes(val?.agreementType)) ? false : true;
      setDisableApplyBtn(isButtonDisable);
    }
    else {
      setDisableApplyBtn(false);
    }
  }
  /**
   * SQ_ACS_5, SQ_ACS_6, SQ_ACS_7, SQ_ACS_8, SQ_ACS_9, SQ_ACS_10, SQ_ACS_11, SQ_ACS_12, SQ_ACS_13
   * @returns
   */
  const bindAvailableCredits = () => {
    return agreementInfo?.customerInfo?.remainingCredits?.map(
      (creditsValue: CreditsValue, index: number) => {
        if (
          (agreementInfo.customerOrderPayment == CONSTANTS.EMPTY_STRING &&
            creditsValue?.storeNumber ===
            sessionStorage.getItem(CONSTANTS.STORE_NUMBER) &&
            creditsValue?.accountBalance > CONSTANTS.ZERO_TWO_DECIMAL_NUMBER &&
            (creditsValue?.bucket === CONSTANTS.CAPITAL_COA ||
              creditsValue?.bucket === CONSTANTS.IP_SUSPENSE ||
              creditsValue?.bucket === CONSTANTS.WEB_LEAD_DEPOSIT)) ||
          creditsValue?.bucket === CONSTANTS.REFER_A_FRIEND ||
          (creditsValue?.storeNumber ===
            sessionStorage.getItem(CONSTANTS.STORE_NUMBER) &&
            creditsValue?.accountBalance > CONSTANTS.ZERO_TWO_DECIMAL_NUMBER &&
            creditsValue?.bucket === CONSTANTS.WEB_LEAD_DEPOSIT)
        ) {
          return (
            <>
              <Grid
                item
                key={index}
                className={`${classes.w100} ${classes.floatLeft}`}
              >
                <>
                  <Typography
                    component={"label"}
                    className={`${classes.formLabel} ${classes.w25} ${classes.mt3} ${classes.floatLeft}`}
                  >
                    {creditsValue.bucket}
                  </Typography>
                  <Box
                    component="span"
                    className={`${classes.labeltxtstyle} ${classes.mt3} ${classes.floatLeft} ${classes.accountBalanceCss}`}
                  >
                    $
                    <Box className={classes.displayInline}>
                      {creditsValue?.bucket === CONSTANTS.REFER_A_FRIEND ? rewardAmount?.displayUpdatedAmount : Number(creditsValue.accountBalance).toFixed(2)}
                    </Box>
                  </Box>
                </>
                <Grid
                  item
                  className={
                    `${classes.width55} ${classes.floatLeft} ${classes.mt2} ${classes.ml6}`}
                >
                  <Grid item className={creditsValue?.bucket === CONSTANTS.REFER_A_FRIEND ?
                    // `${classes.w100} ${classes.displayFlex}`
                    `${classes.inputgroup} ${classes.mb3}`
                    : `${classes.inputgroup} ${classes.mb3}`}>
                    <span className={classes.inputgrouptext}>$</span>
                    <CurrencyInput
                      className={`${classes.formcontrol4} ${classes.textend}`}
                      type="text"
                      disabled={(creditsValue?.bucket === CONSTANTS.REFER_A_FRIEND
                        && agreementInfo.customerInfo?.customerRewardDetails?.isAdvocate && !rewardLoader) ? false : true}
                      onChange={(event) => { rewardsOnChage(event.target.value) }}
                      onBlur={(event) => { rewardsOnBlur(event.target.value) }}
                      id="WL-Deposit"
                      defaultValue={Number(creditsValue.accountBalance).toFixed(
                        2
                      )}
                      value={creditsValue?.bucket === CONSTANTS.REFER_A_FRIEND ? rewardAmount?.editedAmount ?? CONSTANTS.ZREO_TWO_DECIMAL_STRING : Number(creditsValue.accountBalance).toFixed(
                        2
                      )}
                      style={{ maxWidth: '76px' }}
                    />
                    {agreementInfo.customerInfo?.customerRewardDetails?.isReferer ||
                      CONSTANTS.AUTO_APPLIED_ARRAY.includes(creditsValue?.bucket) ? (<span style={{ fontSize: '10px', fontFamily: 'OpenSans-semibold', marginTop: '10px', marginLeft: '10px' }}>{t("Auto Applied")}</span>) : null}
                  </Grid>

                </Grid>
                <Grid container md={12}>
                  <Grid item md={5}>

                  </Grid>
                  <Grid item md={7}>
                    {
                      agreementInfo.isRefundWebleadEnabled &&
                        creditsValue?.bucket === CONSTANTS.WEB_LEAD_DEPOSIT ? (
                        <Grid className={`${classes.w100}`}>
                          <RACButton
                            variant="contained"
                            color="primary"
                            className={` ${classes.refundButtonMargin}`}
                            onClick={() => {
                              agreementInfo.setOpenRefundWebloadPopup(true)
                            }}
                          >
                            {t('Refund Deposit')}
                          </RACButton>
                        </Grid>
                      ) :
                        agreementInfo?.featureFlags?.EnableCustomerRewardPayment == '1' &&
                          creditsValue?.bucket === CONSTANTS.REFER_A_FRIEND &&
                          !agreementInfo.customerInfo?.customerRewardDetails?.isReferer ? (
                          <Grid className={`${classes.w100}`}>
                            <RACButton
                              variant="contained"
                              color="primary"
                              className={` ${classes.refundButtonMargin}`}
                              disabled={rewardLoader || agreementInfo.customerInfo.customerRewardDetails?.isReferer || Number(rewardAmount?.editedAmount) > Number(rewardAmount?.originalAmount) || disableApplyBtn || Number(rewardAmount?.editedAmount) == 0}
                              onClick={() => {
                                // agreementInfo.setOpenRefundWebloadPopup(true);
                                validateEligibleRewardAmount()
                              }}
                              loading={rewardLoader}
                            >
                              {t("Apply")}
                            </RACButton>
                          </Grid>
                        ) : null}
                  </Grid>
                </Grid>

              </Grid>
            </>
          );
        }
      }
    );
  };

  const refundWebleadAmount = async () => {
    setButtonLoader(true);
    const refundCustomerWebLeadAmount =
      agreementInfo.refundWebleadPayloadDetails &&
      agreementInfo.refundWebleadPayloadDetails.map((element: any) => {
        const payload = {
          firstName: agreementInfo.customerInfo.customerDetails[0].firstName,
          lastName: agreementInfo.customerInfo.customerDetails[0].lastName,
          amount: element.paymentInfo.balanceAmount,
          originalExtTransactionId: element.paymentInfo.externalTransactionId,
          customerId: element?.orderNumber,
          cardType: element.paymentInfo.cardType,
          paymentType: element.paymentInfo.paymentType,
          globalCustomerId:
            agreementInfo.customerInfo.customerDetails[0].globalCustomerId,
        };
        return RefundWebLeadAmount(payload);
      });
    console.log('refundCustomerWebLeadAmount', refundCustomerWebLeadAmount);
    if (refundCustomerWebLeadAmount) {
      const refundWebleadResponse = await Promise.all(
        refundCustomerWebLeadAmount
      );
      console.log('refundWebleadResponse', refundWebleadResponse);
      const successApiCallStatus: any = [];
      setButtonLoader(false);
      agreementInfo.setOpenRefundWebloadPopup(false);
      refundWebleadResponse.forEach((element: any) => {
        if (element.statusCode == 'A') {
          successApiCallStatus.push(true);
        } else {
          successApiCallStatus.push(false);
        }
      });

      if (successApiCallStatus.every((status) => status === true)) {
        setMessageType(t('SUCCESS'));
        setMessage(t('Refund Completed Successfully'));
        setMessagePopup(true);
      } else if (
        successApiCallStatus?.length > 1 &&
        successApiCallStatus.some((status) => status === false)
      ) {
        setMessageType(t('FAILED'));
        setMessage(t('Refund was partially completed for this customer.'));
        setMessagePopup(true);
      } else if (successApiCallStatus.some((status) => status === false)) {
        setMessageType(t('ERROR'));
        setMessage(t('An error occurred while processing the Weblead refund.'));
        setMessagePopup(true);
      }
    }
  };

  const webLeadRefundPopup = () => {
    return (
      <>
        <Grid>
          <Grid style={{ marginBottom: '5%' }}>
            <Typography
              style={{
                fontSize: '18px',
                textAlign: 'center',
                fontFamily: 'revert',
                lineHeight: '32px',
              }}
            >
              {t("Do you want to refund the deposit for this customer?")}
            </Typography>
          </Grid>
          <Grid style={{ textAlign: 'center', marginBottom: '2%' }}>
            <RACButton
              variant="outlined"
              color="primary"
              style={{ marginRight: '2%' }}
              onClick={() => {
                agreementInfo.setOpenRefundWebloadPopup(false);
              }}
              disabled={buttonLoader}
            >
              {t("No")}
            </RACButton>
            <RACButton
              variant="contained"
              color="primary"
              style={{ marginLeft: '2%' }}
              onClick={() => {
                refundWebleadAmount();
              }}
              loading={buttonLoader}
            >
              {t("Yes")}
            </RACButton>
          </Grid>
        </Grid>
      </>
    );
  };

  const handleMessageCompletion = () => {
    if (messageType == 'SUCCESS') {
      setMessagePopup(false);
      const updatedRemainingCredits =
        agreementInfo.customerInfo?.remainingCredits?.map(
          (creditsValue: CreditsValue) => {
            if (
              creditsValue?.storeNumber ===
              sessionStorage.getItem(CONSTANTS.STORE_NUMBER) &&
              creditsValue?.accountBalance >
              CONSTANTS.ZERO_TWO_DECIMAL_NUMBER &&
              creditsValue?.bucket === CONSTANTS.WEB_LEAD_DEPOSIT
            ) {
              return {
                ...creditsValue,
                bucket: '',
              };
            }
            return creditsValue;
          }
        );
      agreementInfo.setCustomerInfo((prevState) => ({
        ...prevState,
        remainingCredits: updatedRemainingCredits,
      }));
    } else if (messageType == 'FAILED') {
      window.location.reload();
    } else if (messageType == 'REWARDAMOUNT') {
      rewardAmount = { ...rewardAmount, editedAmount: rewardAmount?.totalRentalAmount };
      setRewardAmount(rewardAmount);
      applyRewards();
      setMessagePopup(false);
    } else {
      setMessagePopup(false);
    }
  };
  const popupContent = () => (
    <Grid container>
      <Grid item md={12} style={{ textAlign: 'center' }}>
        {messageType == 'SUCCESS' ? <TickIcon /> : <Alerticon />}
        <Typography
          variant={'body2'}
          style={{
            fontFamily: 'OpenSans-bold',
            fontSize: '16px',
            letterSpacing: 0,
            marginBottom: '25px',
            marginTop: '15px',
          }}
        >
          {t(message)}
        </Typography>

        <RACButton
          variant="contained"
          color="primary"
          id="assignAlertBtn"
          onClick={() => {
            handleMessageCompletion();
          }}
        >
          {t("ok")}
        </RACButton>
      </Grid>
    </Grid>
  );

  /**
   * SQ_ACS_14 - SQ_ACS_18
   */
  return (
    <>
      <Grid container data-testid="availcreditid" className={`${classes.respw100}`}>
        <Grid
          item
          className={`${classes.w100} ${classes.floatLeft} ${classes.mb2}`}
        >
          <Typography
            variant="h6"
            className={`${classes.floatLeft} ${classes.mt2} ${classes.raccollg8} ${classes.title}`}
          >
            {t("Available Credit")}
          </Typography>
        </Grid>

        <Grid item className={`${classes.w100} ${classes.floatLeft}`}>
          <Card
            className={`${classes.card} ${classes.w100} ${classes.floatLeft} ${classes.p3}`}
            style={{ marginBottom: "20px" }}
          >
            <CardContent className={classes.p0}>
              {bindAvailableCredits()}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <RACModalCard
        isOpen={agreementInfo.openRefundWebLeadPopup}
        maxWidth="xs"
        data-testid="webLeadPopup"
        onClose={() => {
          agreementInfo.setOpenRefundWebloadPopup(false);
        }}
        closeIcon={true}
        // eslint-disable-next-line react/no-children-prop
        children={webLeadRefundPopup()}
        className={classes.title}
        borderRadius="15px"
      />
      <RACModalCard
        borderRadius="20px"
        isOpen={messagePopup}
        maxWidth="xs"
        closeIcon={messageType == 'REWARDAMOUNT' ? true : false}
        onClose={() => {
          setMessagePopup(false);
        }}
        children={popupContent()}
      />
    </>
  );
}
